class TokenManager {
  constructor() {
    this.accessToken = null;
    this.tokenExpiry = null;
    this.refreshPromise = null;
  }

  // Access token lives in memory only — never touches localStorage
  setAccessToken(token, expiresIn = 3600) {
    this.accessToken = token;
    this.tokenExpiry = Date.now() + expiresIn * 1000;
  }

  getAccessToken() { return this.accessToken; }
  hasToken()       { return !!this.accessToken; }

  isTokenExpiring() {
    if (!this.tokenExpiry) return false;
    return Date.now() >= this.tokenExpiry - 60 * 1000;
  }

  // Refresh token is in an httpOnly cookie — frontend never reads or writes it
  clearTokens() {
    this.accessToken = null;
    this.tokenExpiry = null;
    this.refreshPromise = null;
  }

  setRefreshPromise(promise) { this.refreshPromise = promise; }
  getRefreshPromise()        { return this.refreshPromise; }
  clearRefreshPromise()      { this.refreshPromise = null; }

  decodeToken(token) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
      );
      return JSON.parse(jsonPayload);
    } catch { return null; }
  }

  getUserFromToken() {
    if (!this.accessToken) return null;
    const decoded = this.decodeToken(this.accessToken);
    if (!decoded) return null;
    return {
      id:     decoded.sub || decoded.userId,
      email:  decoded.email,
      name:   decoded.name,
      role:   decoded.role,
      avatar: decoded.avatar,
    };
  }
}

const tokenManager = new TokenManager();
export default tokenManager;